import App from './App';
import { createRoot } from 'react-dom/client';
// Replace ReactDOM.render with createRoot
const rootElement = document.getElementById('root');
createRoot(rootElement).render(<App />);